"use client";

import { useState, useRef, useEffect } from "react";

export default function FeedbackBanner() {
  const [open, setOpen] = useState(false);
  const [sent, setSent] = useState(false);
  const [cooldown, setCooldown] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (cooldown) return;

    const form = e.target as HTMLFormElement;

    // Honeypot check
    if (form.company.value !== "") {
      return;
    }

    const data = {
      feedback: form.feedback.value,
      email: form.email.value,
    };

    const res = await fetch("/api/feedback", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (res.ok) {
      setSent(true);
      setCooldown(true);
      form.reset();

      setTimeout(() => {
        setOpen(false);
        setCooldown(false);
      }, 60000); // 1 minute cooldown
    }
  };

  return (
    <div className="max-w-[150px] mx-auto bg-[#F0F4C3] border border-[#D3DC7C] px-3 py-2 mt-6 rounded shadow text-xs text-[#1B475D] flex justify-between items-center">
      <span className="mr-2 whitespace-nowrap">Feedbacks?</span>

      <div className="relative w-full" ref={popoverRef}>
        <div className="flex justify-center">
          <button
            onClick={() => {
              setOpen((prev) => !prev);
              setSent(false);
            }}
            className="bg-[#8EBD9D] hover:bg-[#77A885] text-[#1B475D] text-xs px-3 py-1 rounded font-medium transition"
          >
            💬
          </button>
        </div>

        {open && (
          <div className="absolute top-10 left-1/2 -translate-x-[180px] w-72 bg-white border border-[#D3DC7C] shadow-lg rounded-md p-3 z-50">
            {!sent ? (
              <>
                <h4 className="font-semibold text-xs mb-1 text-[#1B475D]">
                  Feedback
                </h4>
                <form onSubmit={handleSubmit} className="flex flex-col gap-2">
                  {/* Honeypot field */}
                  <input
                    type="text"
                    name="company"
                    autoComplete="off"
                    className="hidden"
                  />

                  <textarea
                    name="feedback"
                    placeholder="Your message..."
                    required
                    rows={2}
                    className="w-full border border-[#D3DC7C] p-1.5 rounded text-xs resize-none"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email (optional)"
                    className="w-full border border-[#D3DC7C] p-1.5 rounded text-xs"
                  />
                  <button
                    type="submit"
                    disabled={cooldown}
                    className={`text-xs px-3 py-1 rounded font-medium transition ${
                      cooldown
                        ? "bg-gray-300 cursor-not-allowed"
                        : "bg-[#8EBD9D] hover:bg-[#77A885] text-[#1B475D]"
                    }`}
                  >
                    {cooldown ? "Please wait..." : "Send"}
                  </button>
                </form>
              </>
            ) : (
              <p className="text-[#4CAF50] font-medium text-xs">
                ✅ Thanks for your feedback!
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
